/**
 * financial_company ids the frontend gates on (authSlice.financialCompany
 * carries the selected account's value). Only list ids that drive UI
 * behavior; the full table lives in the database.
 */
export enum FinancialCompany {
  /** Global American: no loss/damage claims; support cases file in their Zoho Desk. */
  GlobalAmerican = 8,
}
